/**
 * TanStack Query hooks for `payout-threshold-enforcement-min-balance-before-re`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	payoutThresholdEnforcementMinBalanceBeforeReQueryKeys,
	type CreatePayoutThresholdEnforcementMinBalanceBeforeReBody,
	type ListPayoutThresholdEnforcementMinBalanceBeforeReResponse,
	type PayoutThresholdEnforcementMinBalanceBeforeReRow,
} from "./api";

export function usePayoutThresholdEnforcementMinBalanceBeforeReList(): UseQueryResult<ListPayoutThresholdEnforcementMinBalanceBeforeReResponse, Error> {
	return useQuery({
		queryKey: payoutThresholdEnforcementMinBalanceBeforeReQueryKeys.list(),
		queryFn: list,
	});
}

export function usePayoutThresholdEnforcementMinBalanceBeforeReCreate(): UseMutationResult<PayoutThresholdEnforcementMinBalanceBeforeReRow, Error, CreatePayoutThresholdEnforcementMinBalanceBeforeReBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: payoutThresholdEnforcementMinBalanceBeforeReQueryKeys.all });
		},
	});
}

export function usePayoutThresholdEnforcementMinBalanceBeforeReDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: payoutThresholdEnforcementMinBalanceBeforeReQueryKeys.all });
		},
	});
}
